import { SVGProps } from "react";

/**
 * Icône poussette (baby stroller) — silhouette pleine pour rester lisible
 * dès 10–12 px (mobile timeline). Utilise currentColor → s'adapte au thème
 * et au texte blanc des barres timeline.
 *
 * Forme : capote arrondie + caisse + 2 grosses roues + poignée.
 */
export const StrollerIcon = ({
  className,
  size = 14,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    role="img"
    aria-label="Poussette"
    {...props}
  >
    {/* Capote demi-cercle + caisse trapézoïdale en un seul tracé plein */}
    <path d="M3 4a1 1 0 0 0-.7 1.7l1.6 1.6A9 9 0 0 0 3 12h18a9 9 0 0 0-9-9 9 9 0 0 0-3.3.6L6.4 4.3A1 1 0 0 0 5.7 4H3zm1 9 2.2 4.4a1 1 0 0 0 .9.6h9.8a1 1 0 0 0 .9-.6L20 13H4z" />
    {/* Roues pleines */}
    <circle cx="7.5" cy="20" r="2" />
    <circle cx="16.5" cy="20" r="2" />
  </svg>
);

export default StrollerIcon;
